// extracted by mini-css-extract-plugin
export default {"sign_up_form_container":"sign-up-form_sign_up_form_container__INESn"};